var React = require('react');

function ChevronNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 15.4803L1.66838 17L11 8.5L1.66838 0L0 1.5197L7.66324 8.5L0 15.4803Z","fill":"#ED1C24"}));
}

ChevronNext.defaultProps = {"width":"11","height":"17","viewBox":"0 0 11 17","fill":"none"};

module.exports = ChevronNext;

ChevronNext.default = ChevronNext;
